/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Section_Click } from "../../utils/utils";
import { InteractiveResult } from "../SearchResults/SearchListing/InteractiveResult";
import "../SupportSearchHero/SSAutoSuggestions.scss";
const suggestionStyle = {
  cursor: "pointer",
};

// Suggestion for product finder search box
function ProductFinderSuggestion(props: any) {
  let timeout = useRef(setTimeout(() => { }, 0));
  const { resultList, resultListFirstSuggestion, firstSuggestion, controller } = props;
  const { value } = props;
  const [isNoResult, setNoResult] = useState(false);
  const valueInput = document.getElementsByClassName('product-finder-input')[0]?.getAttribute('value');
  const renderedResults = resultList.length > 0 ? resultList : resultListFirstSuggestion;

  // Compare the title with the keyword search to get the index of the keyword in each result
  // Then replace this word with highlight value and push to updateTitle array to use when rendering
  const highlightSearchTerm = (result: any) => {
    const currentTitle = result.title;
    const title = result.title?.toLowerCase();
    const searchValue = value.toLowerCase();
    const index = title.indexOf(searchValue);
    // If returned title contains the search keyword, get the mapped keyword from the returned title and highlight it
    // Otherwise, get the returned title
    const updatedResult = title.indexOf(searchValue) > -1 ? currentTitle.substring(index, index + searchValue.length) : "";
    const updatedValue = updatedResult !== "" ? currentTitle.replace(updatedResult, "<strong>" + updatedResult + "</strong>") : currentTitle;

    return updatedValue;
  }
   // using firstload icon ignore no result component
   useEffect(() => {
    return () => {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        setNoResult(true);
      }, 0);
    };
  }, [resultList, resultListFirstSuggestion]);

  const clickHandler = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const prodName = $(e.target).parent().closest('.oosl').find('.product-name')[0].innerText;
    $("#update-product-name")?.trigger("updateProductName", prodName);
    const url_string = decodeURI(window.location.href);
    const url = new URL(url_string);
    url.searchParams.get("prodName") ? url.searchParams.set("prodName", prodName) : url.searchParams.append("prodName", prodName);
    const newUrl = url.origin + url.pathname + url.search;
    window.history.pushState({path: newUrl}, "", newUrl);
    props.setValueSuggestionsActive(prodName);
    props.setActiveSuggestions(true);
  }

  return (
    <div className="search-hero-dropdown-wrapper">
      <div className="upper-search-dropdown-content">
        {(resultList.length === 0 && resultListFirstSuggestion.length === 0 && isNoResult) && (
          <div className="search-hero-no-results">No results found</div>
        )}
        
        {(resultList.length > 0 || firstSuggestion && resultListFirstSuggestion.length > 0 || props.didYouMean) && (
          <div className="search-content">
            <div className="product-results no-border">
              {props.didYouMean && (
                <>
                <div className="did-you-mean-section">Did you mean: <span className="did-you-mean-value" onClick={() => props.setIsApplyDidYouMean(true)}>{props.didYouMean}</span></div>
                { controller.state.value !== valueInput && (
                  <div className="top-searches-results">
                    <div>No results for "{valueInput}"</div>
                    <div>Top product support for suggested term "{firstSuggestion}"</div>
                  </div>
                )}
                </>
              )}                
              {resultList.length === 0 && resultListFirstSuggestion.length > 0 && firstSuggestion && (
                <div className="top-searches-results">
                  <div>No results for "{value}"</div>
                  <div>Top product support for suggested term "{firstSuggestion}"</div>
                </div>
              )}
              {/* show max 6 results */}
              {renderedResults.map((suggestion: any, index: number) => {
                const spdpPath = `${suggestion.clickUri}#${encodeURIComponent(`idReference=${suggestion.raw[props.anchor]}`)}`;
                const wtbPath = `/shop/wtb/index/index/id/${suggestion.raw.product_id}`;
                const ooslValue : HTMLInputElement | null = document.querySelector("input[name=ooslPath]");
                const currentPage: any = window.location.href;
                const ooslPath = ooslValue?.value + `?prodName=${encodeURIComponent(suggestion.title)}`;
                const redirectPath = props.anchor === "where_to_buy_flag"
                      ? wtbPath
                      : spdpPath;

                if (props.anchor === "oosl" && currentPage.includes(ooslValue)) {
                  return (
                    <a className="oosl" onClick={clickHandler}>
                      <div
                        className="product-name"
                        style={suggestionStyle}
                        key={suggestion.rawValue}
                        dangerouslySetInnerHTML={{
                          __html: highlightSearchTerm(suggestion),
                        }}
                      >
                      </div>
                      <div className="product-support-name">
                        Product support
                      </div>
                    </a>
                  );
                } else {
                  return (
                    <InteractiveResult key={index} result={suggestion} redirectPath={redirectPath} sectionClick={Section_Click.PRODUCT_FINDER}>
                      <div
                        className="product-name"
                        style={suggestionStyle}
                        key={suggestion.rawValue}
                        dangerouslySetInnerHTML={{
                          __html: highlightSearchTerm(suggestion),
                        }}
                      >
                      </div>
                      {props.anchor !== "where_to_buy_flag" && (
                        <div className="product-support-name">
                          Product support
                        </div>
                      )}
                    </InteractiveResult>
                  );
                }
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default ProductFinderSuggestion;
